module.exports = __webpack_public_path__ + "static/img/Simple-Line-Icons.2fe2efe.svg";


//////////////////
// WEBPACK FOOTER
// ./~/simple-line-icons/fonts/Simple-Line-Icons.svg?v=2.4.0
// module id = 875
// module chunks = 3